import * as expenseTypes from "../../types/admin/expenseTypes";

export const getAllExpenseRequestReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case expenseTypes.GET_ALL_EXPENSE_REQUESTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case expenseTypes.GET_ALL_EXPENSE_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        errors: "",
      };
    case expenseTypes.GET_ALL_EXPENSE_REQUESTS_FAIL:
      return {
        ...state,
        loading: false,
        errors: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const getAllExpenseHistoryReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case expenseTypes.GET_ALL_EXPENSE_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case expenseTypes.GET_ALL_EXPENSE_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        errors: "",
      };
    case expenseTypes.GET_ALL_EXPENSE_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        errors: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const addExpenseOfUsersReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case expenseTypes.ADD_EXPENSE_OF_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case expenseTypes.ADD_EXPENSE_OF_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        errors: "",
      };
    case expenseTypes.ADD_EXPENSE_OF_USERS_FAIL:
      return {
        ...state,
        loading: false,
        errors: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const approveExpenseRequestReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case expenseTypes.APPROVE_EXPENSE_REQUEST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case expenseTypes.APPROVE_EXPENSE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        errors: "",
      };
    case expenseTypes.APPROVE_EXPENSE_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        errors: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const rejectExpenseRequestReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case expenseTypes.REJECT_EXPENSE_REQUEST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case expenseTypes.REJECT_EXPENSE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        errors: "",
      };
    case expenseTypes.REJECT_EXPENSE_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        errors: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const deleteExpenseRequestReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case expenseTypes.DELETE_EXPENSE_REQUEST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case expenseTypes.DELETE_EXPENSE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        errors: "",
      };
    case expenseTypes.DELETE_EXPENSE_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        errors: payload,
        info: [],
      };
    default:
      return state;
  }
};
